import React from 'react'
import './skills.css'
import { SkillFrontEnd , SkillBackEnd } from './Data'

const Skills = () => {
    return (
    <>
        <section className="skills section" id="skills">
            <h2 className="section__title">Skills</h2>
            <span className="section__subtitle">My Favorite Skills</span>

            <div className="skills__container container grid section__border">

            {/* <!--==================== SKILLS 1 ====================--> */}
            <div className="skills__content">
                <h3 className="skills__title">
                    <i className="ri-braces-line"></i> Frontend Developer
                </h3>

                <div className="skills__info">
                    {
                        SkillFrontEnd.map((item,index)=>{
                                return(
                                    <div className="skills__data" key={index}>
                                        <div className="skills__blob">
                                            <img src={item.Image} alt="skills"/>
                                        </div>

                                        <h3 className="skills__name">{item.NameSkill}</h3>
                                        <span className="skills__subtitle">{item.SubNameSkill}</span>
                                    </div>
                                )
                        })
                    }
                </div>
            </div>

            {/* <!--==================== SKILLS 2 ====================--> */}
            <div className="skills__content">
                <h3 className="skills__title">
                    <i className="ri-code-line"></i> BackEnd Developer
                </h3>

                <div className="skills__info">
                    {
                        SkillBackEnd.map((item,index)=>{
                            return(
                                <div className="skills__data" key={index}>
                                    <div className="skills__blob">
                                        <img src={item.Image} alt="skills"/>
                                    </div>

                                    <h3 className="skills__name">{item.NameSkill}</h3>
                                    <span className="skills__subtitle">{item.SubNameSkill}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

        </div>
    </section>
    </>
    )
}

export default Skills